import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider, useApp } from "@/context/AppContext";
import AccessGate from "@/pages/AccessGate";
import CalendarPage from "@/pages/CalendarPage";
import HomePage from "@/pages/HomePage";
import CuentaPage from "@/pages/CuentaPage";
import ActivityDetail from "@/pages/ActivityDetail";
import RegisterPage from "@/pages/RegisterPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminActivityForm from "@/pages/AdminActivityForm";
import LegalPage from "@/pages/LegalPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import PagarRestoPage from "@/pages/PagarRestoPage";
import { InterestPopup } from "@/components/InterestPopup";
import { BetaBanner } from "@/components/BetaBanner";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { Footer } from "@/components/Footer";

function RequireAccess({ children }) {
  const { accessToken } = useApp();
  return accessToken ? children : <Navigate to="/" replace />;
}
function RequireAdmin({ children }) {
  const { adminToken } = useApp();
  return adminToken ? children : <Navigate to="/admin" replace />;
}

function Routing() {
  const { accessToken } = useApp();
  return (
    <Routes>
      <Route path="/" element={accessToken ? <Navigate to="/inicio" replace /> : <AccessGate />} />
      <Route path="/inicio" element={<RequireAccess><HomePage /></RequireAccess>} />
      <Route path="/cuenta" element={<RequireAccess><CuentaPage /></RequireAccess>} />
      <Route path="/calendario" element={<RequireAccess><CalendarPage /></RequireAccess>} />
      <Route path="/actividad/:id" element={<RequireAccess><ActivityDetail /></RequireAccess>} />
      <Route path="/actividad/:id/apuntarse" element={<RequireAccess><RegisterPage /></RequireAccess>} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/legal/:slug" element={<LegalPage />} />
      <Route path="/restablecer" element={<ResetPasswordPage />} />
      <Route path="/pagar-resto" element={<PagarRestoPage />} />
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/panel" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
      <Route path="/admin/actividad/:id" element={<RequireAdmin><AdminActivityForm /></RequireAdmin>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <BetaBanner />
          <Routing />
          <Footer />
          <InterestPopup />
          <WhatsAppButton />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
